import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useSetRecoilState } from 'recoil';
import CrewListSelection from '../components/crew/CrewListSelection';
import CrewList from '../components/crew/CrewList';
import DailyToolbar from '../components/dailyUsage/DailyToolbar';
import { _HeaderTitle } from '../_Recoil/atoms';
import { basicStyles } from '../theme';
import ErrorBoundary from '../utils/ErrorBoundary';

import { UserContext } from '../providers/UserProvider';

const Crew = (props) => {
  const { match, history } = props;
  const { user } = useContext(UserContext);
  const classes = basicStyles();
  const setHeaderTitle = useSetRecoilState(_HeaderTitle);
  document.title = 'Crew';
  useEffect(() => setHeaderTitle('Daily Crew'), []);
  return (
    <ErrorBoundary componentName='Crew' user={user}>
      <Grid className={classes.gridItem}>
        <Grid item xs={12} className={classes.gridItem}>
          <div style={{ paddingBottom: '8px' }}>
            <h1>{document.title}</h1>
          </div>
        </Grid>
        <Grid container>
          <DailyToolbar />
        </Grid>
        {typeof match.params.id === 'undefined' ? (
          <>
            <CrewList history={history} match={match} />
          </>
        ) : (
          <CrewListSelection history={history} match={match} />
        )}
      </Grid>
    </ErrorBoundary>
  );
};

Crew.propTypes = {
  match: PropTypes.objectOf(PropTypes.any),
  history: PropTypes.objectOf(PropTypes.any)
};
Crew.defaultProps = {
  match: {
    params: {}
  },
  history: {
    push: () => { }
  }
};
export default Crew;
